<template>
    <div v-if="player_name.length !== 0">
        <div style="display: flex; align-items: center; margin-left: 152px; margin-bottom: 33px; margin-top: 38px">
            <div class="players-select">
                球员：
                <a-select style="margin-right: 10px; min-width: 90px" v-model="selectedPlayer"
                    @change="onChangePlayers(selectedPlayer)">
                    <a-select-option v-for="player in player_name" :value="player" :key="'player-select' + player">
                        {{ player }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="time-select" style="margin-left: 69px;">
                时间：
                <a-date-picker :value="startTime" :locale="locale"
                    @change="(date, dateString) => onChangeDate(dateString, 1)" />
                &nbsp; <span style="font-weight: 400;">—</span> &nbsp;
                <a-date-picker :value="endTime" :locale="locale"
                    @change="(date, dateString) => onChangeDate(dateString, 2)" />
            </div>
        </div>

        <div v-if="data.match_name.length !== 0" class="not-null">
            <div style="display: flex; justify-content: center; align-items: center;">
                <div class="drawChart" :style="{
                    // 'max-width': (6 * rectwidth + 5 * space) + 'px',
                    // 'max-width' : '95%',
                    'margin-left' : '6%',
                    'margin-right' : '6%',
                    'overflow-y': 'hidden', 'overflow-x': 'auto'
                }">
                    <svg :width="getWidth + 12.9" class="components">
                        <g v-for="(name, i) in data.match_name"
                           :key="name + data.position[i].city_cn_name + 'start_time' + data.start_time[i] + 'end_time' + data.end_time[i]"
                           :transform="`translate(${calculateTranslate(i)}, 0)`"
                        >
                            <rect v-if="name !== '返京'" class="upper-rect" x="0" y="0"
                                :width=rectwidth height="76" rx="5" ry="5" style="fill: #00375B;"
                                @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)"
                            />
                            <text v-if="name !== '返京'" class="upper-text" :x=centerPosition y="40"
                                text-anchor="middle" alignment-baseline="middle" style="fill: white"
                                @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)"
                            >
                                <tspan :x=centerPosition dy="-0.5em">{{ name }}</tspan>
                                <tspan :x=centerPosition dy="1.5em">{{ data.start_time[i] + '-' }} {{ data.end_time[i] }}</tspan>
                            </text>
                            <line v-if="name !== '返京'" class="connector" :x1="centerPosition - 1" y1="75" :x2="centerPosition - 1" y2="115"
                                style="stroke: black; stroke-width: 1"
                            />
                            <line v-if="name !== '返京'" class="connector" :x1="centerPosition + 1" y1="75" :x2="centerPosition + 1" y2="115"
                                style="stroke: black; stroke-width: 1"
                            />
                            <rect v-if="name !== '返京'" class="lower-rect" x="0" y="115"
                                :width=rectwidth height="30" rx="5" ry="5" style="fill: white; stroke: #00375B; stroke-width: 1px; "
                                @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)"
                            />
                            <rect v-else class="lower-rect" x="0" y="115"
                                :width=rectwidth/2 height="30" rx="5" ry="5" style="fill: white; stroke: #00375B; stroke-width: 1px; "
                                @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)"
                            />
                            <text v-if="name !== '返京'" class="lower-text" :x=centerPosition y="130"
                                text-anchor="middle" alignment-baseline="middle" style="fill: black"
                                @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)">
                                {{ data.position[i].city_cn_name }} {{ data.site_number[i] }}
                            </text>
                            <text v-else class="lower-text" :x=centerPosition/2 y="130"
                                text-anchor="middle" alignment-baseline="middle" style="fill: black"
                                @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)">
                                {{ data.position[i].city_cn_name }}
                            </text>
                            <text class="lower-text" :x=centerPosition-125 y="120"
                                text-anchor="middle" alignment-baseline="middle" style="fill: black"
                            >
                                {{ calculateDistance([data.position[i-1]?.longitude,data.position[i-1]?.latitude],[data.position[i]?.longitude,data.position[i]?.latitude]).toFixed(0).toString() }}
                            </text>
                        </g>
                        <line v-for="(_, i) in this.data.match_name.slice(0, -1)" :key="'line-' + i"
                            :x1="`${calculateX1(i)}`" :y1="130" :x2="`${calculateX2(i)}`" :y2="130"
                            :style="{
                                stroke: getColors[i],
                                'stroke-width': selectLine === i ? '4px' : '2px',
                                opacity: selectLine === -1 ? 1 : (selectLine === i ? 1 : 0.5)
                            }"
                            @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)"
                        />
                        <circle v-for="(name, i) in this.data.match_name.slice(0, -1)" :key="name + i"
                            :cx="`${calculateX1(i)}`" :cy="130" :r="selectLine === -1 ? 5 : (selectLine === i ? 7 : 5)"
                            :style="{
                                fill: getColors[i],
                                opacity: selectLine === -1 ? 1 : (selectLine === i ? 1 : 0.5)
                            }"
                            @mouseover="handleLineMouseOver(i)" @mouseout="handleLineMouseOut()" @click="handleMouseClick(i)"
                        />
                    </svg>
                </div>
            </div>
            <div class="map-container">
                <div ref="mapRef" class="map"></div>
            </div>
        </div>
        <div v-else>
            <a-empty description="暂无数据"></a-empty>
        </div>

    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js';
import 'mapbox-gl/dist/mapbox-gl.css';
import {getInfoForMapView} from '@/api'
import {getTeamPlayersWithoutSelectCheck} from '../api/index';
import mapMarker from "../assets/map-marker-alt-solid.svg"
import utils from "@/utils/cardIcon";

let today = new Date();
export default {
    data() {
        return {
            rectwidth: 175,
            space: 75,
            centerPosition: 85,
            teamPlayers: '',
            currentTeam: '',
            map: null,
            marker: null,
            centerInit: '',
            locale,
            lineColors: ["#E41A1C", "#FF7F00", "#377EB8", "#4DAF4A", "#FF7F00"],
            getColors: [],
            showCircle: -1,
            selectLine: -1,
            circleX: 0,
            startTime: '2025-01-01',
            endTime: today.getFullYear() + '-' +
                ('0' + (today.getMonth() + 1)).slice(-2) + '-' +
                ('0' + today.getDate()).slice(-2),
            selectedPlayer: '',
            player_id: [],
            player_name: [],
            data: {
                match_name: [],
                start_time: [],
                end_time: [],
                position: [],
                return_list: [],
                site_number: [],
            },
            go_home: {
                match_name: "返京",
                position: {
                    "city_cn_name": "中国北京",
                    "longitude": "116.4",
                    "latitude": "39.9"
                },
                site_number: "中国北京"
            },
            markerList:[]
        };
    },
    created() {
        const userInfo = this.$store.state.userInfo
        if (userInfo) {
            this.$router.push('/map')
        } else {
            this.$router.push('/login')
        }
    },
    mounted() {
        this.currentTeam = this.$store.state.currentTeam;
        this.getPlayerOptions();
    },
    computed: {
        getWidth() {
            const intetval = this.space
            const unitW = this.rectwidth
            return this.data.match_name.length * (intetval + unitW)
        },
    },
    watch: {
        '$store.state.currentTeam'() {
            this.selectedPlayer = ''
            this.startTime = '',
            this.endTime = '',
            this.data = {
                match_name: [],
                start_time: [],
                end_time: [],
                position: [],
                site_number: [],
            },
            this.getOptions()
        }
    },
    methods: {
        getOptions() {
            this.$store.commit('setLoading', true)
            this.currentTeam = this.$store.state.currentTeam
            this.getPlayerOptions().then(() => {
                this.$store.commit('setLoading', false)
            })
        },
        async getPlayerOptions() {
            const response = await getTeamPlayersWithoutSelectCheck(this.currentTeam)
            if (response.status === 200) {
                if (response.data.success) {
                    for (let i = 0; i < response.data.players.length; ++i) {
                        this.$set(this.player_name, i, response.data.players[i].player_name);
                        this.$set(this.player_id, i, response.data.players[i].player_id);
                    }
                }
            }
        },
        async asyncQuery(startTime, endTime, player) {
            try {
                const response = await getInfoForMapView(startTime, endTime, player)
                if (response.status === 200) {
                    return response.data;
                }
            }
            catch (error) {
                console.error('查询时发生错误:', error.message, error.response);
            }
        },
        queryInfo(startTime, endTime, player) {
            this.asyncQuery(startTime, endTime, player).then(
                r => {
                    this.changeInfo(r.data.sort(utils.compareFnDate))
                }
            )
        },
        async setDataInThisCom(newData) {
            this.data = newData
        },
        changeInfo(data) {
            let new_match_name = []
            let new_start_time = []
            let new_end_time = []
            let new_position = []
            let new_site_number = []
            new_match_name.push(data[0].match_name)
            new_start_time.push(data[0].start_date)
            new_end_time.push(data[0].end_date)
            new_position.push(data[0].position)
            new_site_number.push("（1）")
            let site_number = 1
            for (let i = 0; i < data.length - 1; ++i) {
                if(this.needGoBeijing(data[i], data[i + 1])) {
                    new_match_name.push(this.go_home.match_name)
                    new_start_time.push(data[i].end_date)
                    new_end_time.push(data[i + 1].start_date)
                    new_position.push(this.go_home.position)
                    new_site_number.push(this.go_home.site_number)
                }
                new_match_name.push(data[i + 1].match_name)
                new_start_time.push(data[i + 1].start_date)
                new_end_time.push(data[i + 1].end_date)
                new_position.push(data[i + 1].position)
                site_number = site_number + 1
                new_site_number.push("（" + site_number.toString()+"）")
            }
            new_match_name.push(this.go_home.match_name)
            new_start_time.push(data[data.length-1].end_date)
            new_end_time.push(data[data.length-1].end_date)
            new_position.push(this.go_home.position)
            new_site_number.push(this.go_home.site_number)
            this.setDataInThisCom({
                "match_name": new_match_name,
                "start_time": new_start_time,
                "end_time": new_end_time,
                "position": new_position.map(r=>{
                      return {
                        ...r,
                        longitude:parseFloat(r.longitude),
                        latitude: parseFloat(r.latitude)
                      }
                    }
                ),
                "site_number": new_site_number,
            }).then(() => {
                this.centerInit = this.getCenter()
                let newColorList = []
                for (let i = 0; i < this.data.match_name.length - 1; ++i) {
                    const startPoint = [this.data.position[i].longitude, this.data.position[i].latitude];
                    const endPoint = [this.data.position[i + 1].longitude, this.data.position[i + 1].latitude];

                    let distance = this.calculateDistance(startPoint, endPoint);
                    newColorList.push(this.setColors(distance))
                }
                this.getColors = newColorList

                let newReturnList = []
                let i = 0
                while(i < this.data.match_name.length - 2) {
                    if(this.data.match_name[i] === "返京" && this.data.match_name[i + 2] === "返京") {
                        newReturnList[i] = true
                        newReturnList[i + 1] = false
                        i = i + 2
                    }
                    else {
                        newReturnList[i] = true
                        i++
                    }
                }
                if(i === this.data.match_name.length - 2) {
                    newReturnList[i] = true
                }
                this.data.return_list = newReturnList
                // console.log('map' + this.getColors)
                this.renderMap();
                // console.log(this.data.match_name[0])
                // console.log('render' + this.getColors[0])
            })
        },
        calculateTranslate(i) {
            let translate = i * (this.space + this.rectwidth)
            for (let j = 0; j < i; ++j) {
                if(this.data.match_name[j] === "返京")
                    translate = translate - this.rectwidth / 2
            }
            return translate
        },
        calculateX1(i) {
            let translate = this.calculateTranslate(i) + this.rectwidth
            if(this.data.match_name[i] === "返京")
                translate = translate - this.rectwidth / 2
            return translate
        },
        calculateX2(i) {
            return this.calculateX1(i) + this.space
        },
        // TODO 距离
        needGoBeijing(data1, data2) {
            if(data1.location === "中国北京" || data2.location === "中国北京") {
                return false;
            }
            let date1_p = Date.parse(data1.end_date);
            let date2_p = Date.parse(data2.start_date);
            if(date2_p - date1_p > 1000 * 60 * 60 * 24 * 4) { // 修改最后数字为天数
                return true;
            }

            if(data1.location.includes("中国") && !data2.location.includes("中国") || !data1.location.includes("中国") && data2.location.includes("中国")) {
                return true;
            }
            // console.log('true',data1.end_date,data2.start_date)
            // let direct_distant = this.calculateDistance([data1.position.longitude, data1.position.latitude], [data2.position.longitude, data2.position.latitude]).toFixed(0);
            // let indirect_distant = this.calculateDistance([data1.position.longitude, data1.position.latitude], [this.go_home.position.longitude, this.go_home.position.latitude]).toFixed(0)
            //     + this.calculateDistance([this.go_home.position.longitude, this.go_home.position.latitude], [data2.position.longitude, data2.position.latitude]).toFixed(0);
            // const threshold_distant = 2000;
            // if(direct_distant < indirect_distant - threshold_distant) {
            //     console.log("dis",direct_distant,indirect_distant)
            //     return true;
            // }
            console.log('do not need goto beijing', data1, data2)
            return false;
        },
        handleLineMouseOver(index) {
            this.showCircle = index;
            this.circleX = (index + 1) * 150 + 50 * index + 50;
            this.selectLine = index;
            for (let i = 0; i < this.data.match_name.length - 1; i++) {
                if(this.map.getLayer("arc" + i))
                    this.map.setPaintProperty("arc" + i, "line-opacity", 0.2);
                if(this.map.getLayer("airplane" + i))
                    this.map.setPaintProperty("airplane" + i, "icon-opacity", 0.2);
            }
            if(this.map.getLayer("arc" + index))
                this.map.setPaintProperty("arc" + index, "line-opacity", 1);
            if(this.map.getLayer("airplane" + index))
                this.map.setPaintProperty("airplane" + index, "icon-opacity", 1);
            this.addMarkerToMap(this.data.position[index].latitude, this.data.position[index].longitude, mapMarker)
        },
        handleLineMouseOut() {
            this.showCircle = -1;
            this.selectLine = -1;
            for (let i = 0; i < this.data.match_name.length - 1; i++) {
                if(this.map.getLayer("arc" + i))
                    this.map.setPaintProperty("arc" + i, "line-opacity", 1);
                if(this.map.getLayer("airplane" + i))
                    this.map.setPaintProperty("airplane" + i, "icon-opacity", 1);
            }
            if (this.marker) {
                this.marker.remove();
            }
        },
        handleMouseClick(index) {
            this.map.setCenter([this.data.position[index].longitude, this.data.position[index].latitude]);
        },
        queryPlayerId(playerName) {
            for (let i = 0; i < this.player_name.length; ++i) {
                if (playerName === this.player_name[i]) return this.player_id[i];
            }
            return -1;
        },
        onChangePlayers(playString) {
            this.selectedPlayer = playString
            if (this.startTime !== '' && this.endTime !== '' && this.selectedPlayer !== '') {
                const playerId = this.queryPlayerId(this.selectedPlayer)
                this.queryInfo(this.startTime, this.endTime, playerId)
            }
        },
        onChangeDate(dateString, index) {
            if (index === 1) {
                this.startTime = dateString
            }
            else {
                this.endTime = dateString
            }
            if (this.startTime !== '' && this.endTime !== '' && this.selectedPlayer !== '') {
                const playerId = this.queryPlayerId(this.selectedPlayer)
                this.queryInfo(this.startTime, this.endTime, playerId)
            }
        },
        getLatitudeRange() {
            let minLatitude = Infinity;
            let maxLatitude = -Infinity;
            for (let i = 0; i < this.data.position.length; i++) {
                const latitude = this.data.position[i].latitude;
                if (latitude < minLatitude) {
                    minLatitude = latitude;
                }
                if (latitude > maxLatitude) {
                    maxLatitude = latitude;
                }
            }
            return maxLatitude - minLatitude;
        },
        getLongitudeRange() {
            let minLongitude = Infinity;
            let maxLongitude = -Infinity;
            for (let i = 0; i < this.data.position.length; i++) {
                const longitude = this.data.position[i].longitude;
                if (longitude < minLongitude) {
                    minLongitude = longitude;
                }
                if (longitude > maxLongitude) {
                    maxLongitude = longitude;
                }
            }
            return maxLongitude - minLongitude;
        },
        getCenter() {
            let minLongitude = Infinity;
            let maxLongitude = -Infinity;
            let minLatitude = Infinity;
            let maxLatitude = -Infinity;
            for (let i = 0; i < this.data.position.length; i++) {
                const longitude = this.data.position[i].longitude;
                const latitude = this.data.position[i].latitude;
                if (longitude < minLongitude) {
                    minLongitude = longitude;
                }
                if (longitude > maxLongitude) {
                    maxLongitude = longitude;
                }
                if (latitude < minLatitude) {
                    minLatitude = latitude;
                }
                if (latitude > maxLatitude) {
                    maxLatitude = latitude;
                }
            }
            let centerLongitude = ((minLongitude) + (maxLongitude)) / 2;
            let centerLatitude = ((minLatitude) + (maxLatitude)) / 2;
            return [centerLongitude, centerLatitude]
        },
        toRadians(degrees) {
            return degrees * Math.PI / 180;
        },
        toDegrees(radians) {
            return radians * 180 / Math.PI;
        },
        calculateDistance(startPoint, endPoint) {
            const [startLng, startLat] = startPoint;
            const [endLng, endLat] = endPoint;
            const earthRadius = 6371;
            const dLng = this.toRadians(endLng - startLng);
            const dLat = this.toRadians(endLat - startLat);

            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.toRadians(startLat)) * Math.cos(this.toRadians(endLat)) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            return earthRadius * c;
        },
        setColors(distance) {
            let newColor = null
            if (distance <= 2500) newColor = this.lineColors[3]
            else if (distance <= 5000) newColor = this.lineColors[2]
            else if (distance <= 7500) newColor = this.lineColors[1]
            else newColor = this.lineColors[0]
            return newColor
        },
        renderMap() {
            if (this.data.match_name[0] !== '' && this.data.position[0]) {
                if (this.map) {
                    this.map.remove();
                }
                mapboxgl.accessToken = 'pk.eyJ1IjoiamltYS1jcyIsImEiOiJjbHAyMHhuZG4wa29mMnBxaTM1ejZnajh6In0.0GpkMui9Hz6i-3ILL1RQxg';
                this.map = new mapboxgl.Map({
                    container: this.$refs.mapRef,
                    style: 'mapbox://styles/jima-cs/cm3pfk5pj000p01sq1cyl2ccj',
                    center: this.centerInit,
                    projection: 'equalEarth'
                });

                this.map.on('load', () => {
                    for (let i = 0; i < this.data.match_name.length - 1; ++i) {
                        const startPoint = [this.data.position[i].longitude, this.data.position[i].latitude];
                        const endPoint = [this.data.position[i + 1].longitude, this.data.position[i + 1].latitude];
                        let startPointFloat = startPoint.map(coord => parseFloat(coord));
                        let endPointFloat = endPoint.map(coord => parseFloat(coord));
                        if (startPointFloat[0] === endPointFloat[0] && startPointFloat[1] === endPointFloat[1]) {
                            endPointFloat[1] += 1;
                        }
                        // console.log('DEBUG',startPointFloat,endPointFloat)
                        const curveCoordinates = this.getCurveCoordinates(startPointFloat, endPointFloat);
                        // console.log('DEBUG',startPointFloat,endPointFloat,curveCoordinates)
                        if(this.data.return_list[i])
                            this.drawArc(this.map, curveCoordinates, i, "#7a9db3");
                        else
                            this.drawArc(this.map, curveCoordinates, i, "#4da9a9");
                        this.drawAirplane(this.map, curveCoordinates, i);
                        // let noteCoords = [[(startPointFloat[0]+endPointFloat[0])/2,(startPointFloat[1]+endPointFloat[1])/2]]
                        // this.drawDistance(this.map, curveCoordinates, i);
                        if(this.data.site_number[i]==="中国北京"){
                          this.addNumberMarkerToMap(this.map, endPointFloat,i+1)
                        }else{
                          this.addNumberMarkerToMap(this.map, startPointFloat,i)
                        }

                    }
                    const latitudeRange = this.getLatitudeRange();
                    const longitudeRange = this.getLongitudeRange();
                    const maxRange = Math.max(latitudeRange, longitudeRange);
                    const zoom = Math.log2(180 / maxRange) - 1;
                    this.map.setZoom(zoom);
                });
            } else {
                console.log("null");
            }
        },
        drawArc(map, curveCoordinates, mapId, color) {
            map.addLayer({
                "id": "arc" + mapId,
                "type": "line",
                "source": {
                    "type": "geojson",
                    "data": {
                        "type": "Feature",
                        "properties": {},
                        "geometry": {
                            "type": "LineString",
                            "coordinates": curveCoordinates
                        }
                    }
                },
                "layout": {
                    "line-cap": "round",
                    "line-join": "round"
                },
                "paint": {
                    "line-color": color,
                    "line-width": 2
                }
            });
        },
        drawAirplane(map, curveCoordinates, mapId) {
            let [longitude1, latitude1] = curveCoordinates[49]
            let [longitude2, latitude2] = curveCoordinates[51]
            longitude1 = this.toRadians(longitude1);
            latitude1 = this.toRadians(latitude1);
            longitude2 = this.toRadians(longitude2);
            latitude2 = this.toRadians(latitude2);

            const x = Math.cos(latitude1) * Math.sin(latitude2) - Math.sin(latitude1) * Math.cos(latitude2) * Math.cos(longitude2 - longitude1);
            const y = Math.sin(longitude2 - longitude1) * Math.cos(latitude2);
            let bearing = Math.atan2(y, x);
            bearing = this.toDegrees(bearing);
            bearing = (bearing + 360) % 360;

            const startPoint = [this.data.position[mapId]?.longitude, this.data.position[mapId]?.latitude]
            const endPoint = [this.data.position[mapId + 1]?.longitude, this.data.position[mapId + 1]?.latitude]
            const distance = this.calculateDistance(startPoint, endPoint).toFixed(0)

            map.addLayer({
                'id': 'airplane' + mapId,
                'source': {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': [
                            {
                                'type': 'Feature',
                                'properties': {
                                    "number": distance
                                },
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': curveCoordinates[50]
                                }
                            }
                        ]
                    }
                },
                'type': 'symbol',
                'layout': {
                    'icon-image': 'airport',
                    'icon-size': 2.0,
                    'icon-rotate': bearing,
                    'icon-rotation-alignment': 'map',
                    'icon-allow-overlap': true,
                    'icon-ignore-placement': true,
                    'text-field': '{number}',
                    'text-font': ['Open Sans Bold'],
                    'text-size': 16,
                    'text-anchor': 'bottom',
                    'text-offset': [0, 2]
                },
                "paint": {
                    "text-color": "#ffffff"
                }
            });
        },
        getCurveCoordinates(startPoint, endPoint) {
            const curveCoordinates = [];

            const lineVec = [endPoint[0] - startPoint[0], endPoint[1] - startPoint[1]];
            const normalVec = [-lineVec[1], lineVec[0]];
            const length = Math.sqrt(normalVec[0] * normalVec[0] + normalVec[1] * normalVec[1]);
            const unitNormalVec = [normalVec[0] / length, normalVec[1] / length];

            const controlPoint1 = [
                startPoint[0] + lineVec[0] * 0.3 + unitNormalVec[0] * length / 20,
                startPoint[1] + lineVec[1] * 0.3 + unitNormalVec[1] * length / 20
            ];
            const controlPoint2 = [
                endPoint[0] - lineVec[0] * 0.3 + unitNormalVec[0] * length / 20,
                endPoint[1] - lineVec[1] * 0.3 + unitNormalVec[1] * length / 20
            ];

            for (let t = 0; t <= 1; t += 0.01) {
                const x =
                    Math.pow(1 - t, 3) * startPoint[0] +
                    3 * Math.pow(1 - t, 2) * t * controlPoint1[0] +
                    3 * (1 - t) * Math.pow(t, 2) * controlPoint2[0] +
                    Math.pow(t, 3) * endPoint[0];

                const y =
                    Math.pow(1 - t, 3) * startPoint[1] +
                    3 * Math.pow(1 - t, 2) * t * controlPoint1[1] +
                    3 * (1 - t) * Math.pow(t, 2) * controlPoint2[1] +
                    Math.pow(t, 3) * endPoint[1];

                curveCoordinates.push([x, y]);
            }
            curveCoordinates.push(endPoint);

            return curveCoordinates;
        },
        addMarkerToMap(latitude, longitude, imageUrl) {
            const markerElement = document.createElement('div');
            const imgElement = document.createElement('img');
            imgElement.src = imageUrl;
            imgElement.style.width = '20px';
            imgElement.style.height = '20px';

            markerElement.appendChild(imgElement);

            this.marker = new mapboxgl.Marker(markerElement)
                .setLngLat([longitude, latitude])
                .setOffset([0, -20])
                .addTo(this.map);
        },
        addNumberMarkerToMap(map,end,mapId) {
            if(this.data.site_number[mapId]!=="中国北京"){
                // 创建一个div元素作为标记
                const el = document.createElement('div');
                el.className = 'marker'; // 可以添加一个类来样式化这个标记
                el.style.backgroundImage = 'url(https://api.mapbox.com/styles/v1/mapbox/streets-v11/sprite/2/1/2.png)'; // 使用Mapbox的默认标记图标
                el.style.backgroundSize = '20px 20px';
                el.style.width = '20px';
                el.style.height = '20px';
                el.style.backgroundPosition = '0px 0px';
                el.style.backgroundRepeat = 'no-repeat';
                el.style.position = 'absolute';
                el.style.cursor = 'pointer';
                el.style.fontSize = '10px';
                el.style.color = '#ffffff';
                el.style.fontWeight = 'bold';
                el.innerText = this.data.site_number[mapId]; // 设置标记的文本为序号
                el.style.display = 'flex';
                el.style.alignItems = 'center';
                el.style.justifyContent = 'center';

                // 创建一个Marker实例并添加到地图上
                const marker = new mapboxgl.Marker(el, {
                    anchor: 'bottom', // 根据需要调整对齐方式
                    offset: [0, 10] // 根据需要调整偏移量
                })
                .setLngLat(end)
                .addTo(map);

                this.markerList.push(marker);
                // 调整标记字体大小的函数
                const adjustFontSize = (zoom) => {
                    const fontSize = 16 + zoom * 0.5; // 根据缩放级别计算字体大小
                    el.style.fontSize = `${fontSize}px`;
                };

                // 监听地图缩放事件
                map.on('zoom', () => {
                    adjustFontSize(map.getZoom());
                });

                // 初始化调整
                adjustFontSize(map.getZoom());
            }
        }

    }
};
</script>

<style>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

.row {
    display: flex;
    align-items: center;
}

.blue-box {
    width: 100px;
    height: 50px;
    background-color: #00375B;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}

.white-box {
    width: 100px;
    height: 50px;
    background-color: #fff;
    border: 1px solid #000;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.line {
    stroke-dasharray: 1, 5;
}

.map-container {
    position: relative;
    width: 95%;
    height: 65vh;
    margin-top: 30px;
    margin-left: 50px;
    margin-right: 50px;
    border: 2px solid #00375B;
}

.map {
    width: 100%;
    height: 100%;
}

.drawChart::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.drawChart::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 20px;
}

.drawChart::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 20px;
}

.drawChart::-webkit-scrollbar-thumb:hover {
    background-color: #555;
}
</style>
